/* eslint-disable */
export default {
    cp_teams_navbar_title: "Teams",
    cp_teams_navbar_search_placeholder: "Search teams",
    cp_teams_general_error: "An error occurred while processing your request.",
    cp_teams_sidebar_title: "Organisations",
    cp_teams_sidebar_search_placeholder: "Search organisations",
    cp_teams_team_card_manager: "Manager",
    cp_teams_team_card_type_team: "Team",
    cp_teams_team_card_teammembers: "Team members",
    cp_teams_footer_page: "Page",
    cp_teams_no_teams: "No teams found",
    cp_teams_team_card_no_teammembers: "No team members",
    cp_teams_sidebar_empty_organisation: "No organisation found.",
    cp_teams_footer_save_button: "Save",
    cp_teams_footer_status_saved: "Saved",
    cp_teams_footer_status_unsaved: "There are unsaved changes",
    cp_teams_navbar_back_button: "Back to Teams overview",
    cp_teams_form_section_team_title: "Team",
    cp_teams_form_section_team_description: "Team settings",
    cp_teams_form_section_team_members_title: "Team members",
    cp_teams_form_section_team_members_description: "Manage the team members of this team.",
    cp_teams_form_section_team_field_name_label: "Team name",
    cp_teams_form_section_team_members_field_search_placeholder: "Search for team members",
    cp_teams_form_section_team_members_field_search_no_results: "No results",
    cp_teams_form_section_team_members_button_add: "Add team member",
    cp_teams_form_saved: "Team saved",
    cp_teams_generic_error: "Something went wrong",
    cp_teams_create_new_team_button_label: "Create team",
    cp_teams_team_created_successfully_message: "The team has been successfully created",
    cp_teams_new_team_modal_title: "What team are you creating?",
    cp_teams_new_team_modal_subtitle: "Determine all the settings of this new team",
    cp_teams_new_team_modal_organisation_setting_title: "Organisation of this team",
    cp_teams_new_team_modal_organisation_setting_description: "There you can find your participants",
    cp_teams_new_team_modal_name_setting_title: "Team name",
    cp_teams_new_team_modal_name_setting_description: "What is the name of this team?",
    cp_teams_new_team_modal_variant_setting_description: "What kind of team is this?",
    cp_teams_new_team_modal_variant_setting_title: "Type of team",
    cp_teams_advisory_team_title: "Advisory team",
    cp_teams_advisory_team_description: "A group of experts who provide strategic guidance, insights, and recommendations to support decision-making in a specific domain.",
    cp_teams_creative_team_title: "Creative team",
    cp_teams_creative_team_description: "A group of professionals who collaborate to develop ideas and produce creative content, often in fields like marketing, design, or media.",
    cp_teams_management_team_title: "Management team",
    cp_teams_management_team_description: "Leaders responsible for setting direction, making strategic decisions, and overseeing the performance of an organization or department.",
    cp_teams_operational_team_title: "Operational team",
    cp_teams_operational_team_description: "A group responsible for carrying out ongoing, routine tasks that support the core functions of an organization.",
    cp_teams_project_team_title: "Project team",
    cp_teams_project_team_description: "A temporary group assembled to achieve specific goals within a defined timeline and scope.",
    cp_teams_service_team_title: "Service team",
    cp_teams_service_team_description: "A group of professionals who work collaboratively to deliver support to internal or external clients",
    cp_teams_unknown_team_description: "Use when none of the other options applies",
    cp_teams_unknown_team_title: "Other",
    cp_teams_empty_report_title: "Report generation failed",
    cp_teams_empty_report_text: "Navigate to the teams overview page",
    cp_teams_role_applicant: "Applicant",
    cp_teams_role_member: "Team Member",
    cp_teams_role_manager: "Team Manager",
    cp_teams_add_team_member_modal_field_participant_label: "Participant",
    cp_teams_add_team_member_modal_field_participant_placeholder: "Select participant",
    cp_teams_add_team_member_modal_field_role_label: "Role",
    cp_teams_add_team_member_modal_field_role_placeholder: "Select role",
    cp_teams_add_team_member_modal_title: "Add a new team member",
    cp_teams_add_team_member_modal_subtitle: "Who do you want to add to this team?",
    cp_teams_add_team_member_modal_field_participant_error: "Please select a participant",
    cp_teams_add_team_member_modal_field_role_error: "Please select a role"
};
